import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { PrimaryButton } from "@normasteaching/norma-ui";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { useAllPromos } from "../../ProductService/NormasTeachingPromo/useAllPromos.ts";
import { AdminPromoTable } from "./AdminPromoTable.tsx";

export const AdminAllPromosScreenPath = "/admin/normasteaching/all-promos";
export const CreatePromoScreenPath = "/admin/normasteaching/create-promo";

export function AdminAllPromosScreen() {
  const { promos, isLoading } = useAllPromos();
  const navigate = useNavigate();

  if (isLoading) return <FullPageLoading />;

  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className="flex-1 p-4 flex flex-col gap-4">
          <div className="flex items-center justify-between gap-2 md:flex-row flex-col">
            <h1 className="font-bold text-3xl flex-1">
              Promo Norma's Teaching
            </h1>
            <div>
              <PrimaryButton
                iconRight={<Plus className="w-5" />}
                label="Nuova promo"
                onClick={() => navigate(CreatePromoScreenPath)}
              />
            </div>
          </div>
          <div className="overflow-x-auto">
            <AdminPromoTable promos={promos} />
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
